<template>
  <v-dialog
    v-model="showWindow"
    scrollable
    max-width="1000"
    max-height="90%"
    min-width="600px"
  >
    <v-card height="100%"  :loading="!isFetchedOrder || isLoading">
      <v-card-text class="pt-5">
        <h2 class="pa-3 pt-2">{{ $t("common.comment") }}</h2>
        <table
          v-if="order"
          class="mx-3 overflow-y-auto"
          style="max-height: 200px; display: block"
        >
          <tr v-for="item in logs" class="px-3 pb-2">
            <td class="text-no-wrap" valign="top">
              {{ item.date | moment("DD.MM.YYYY") }}
              <br/>
              {{ item.date | moment("HH:mm") }}
            </td>
            <td class="text-no-wrap" valign="top">
              <b>[{{ item.user }}]</b>
            </td>
            <td>
              <span v-html="item.action"></span>
            </td>
          </tr>
        </table>

        <v-layout class="px-3 pb-2">
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                v-model="comment.text"
                :label="$t('common.comment')"
                :loading="isLoading"
              ></v-textarea>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      elevation="0"
                      class="mt-4"
                      v-on="on"
                      :title="$t('common.documents')"
                      :loading="isLoading"
                  >
                    <v-icon x-small>fa-chevron-down</v-icon>
                    {{ $t('viewSettings.sms_templates.title') }}
                  </v-btn>
                </template>
                <v-list offset-y>
                  <v-list-item
                      v-for="template in smsTemplates.filter(
                        (el) => el.type === 'personal'
                      )"
                  >
                    <v-list-item-title class="pointer" @click="applySmsTemplate(template)">
                      {{template.name}}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-checkbox v-model="comment.sms" label="SMS"> </v-checkbox>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-checkbox v-model="comment.email" label="E-mail" :disabled="isDisabledEmail"> </v-checkbox>
            </v-col>
            <v-col cols="3" class="text-right px-0 py-0">
              <v-btn
                :disabled="!(comment.text && comment.text.length > 3)"
                :loading="savingInProgress || !isFetchedOrder"
                class="mr-2 mt-4"
                color="primary"
                elevation="0"
                @click="
                  $store.dispatch('orders/ordersCommentStore');
                  commentWindow = false;
                "
                @keyup.enter="
                  $store.dispatch('orders/ordersCommentStore');
                  commentWindow = false;
                "
              >
                {{ comment.sms || comment.email ? $t("common.save_and_send") : $t("common.save") }}
              </v-btn></v-col
            >
          </v-row>
        </v-layout>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CalendarForm from "@/components/calendar/CalendarForm";

export default {
  name: "OrderMessagesWindow",
  mixins: [CommonMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: null
  },
  data: () => ({
    order: null
  }),
  mounted() {},
  computed: {
    ...mapFields('sms_templates', ["smsTemplates", "isLoading"]),
    ...mapFields("orders", ["comment", "fetched", "savingInProgress", "isFetchedOrder"]),
    isDisabledEmail(){
      if(!this.order || !this.order.customer){
        return true
      }
      if(!this.order.customer.email || this.order.customer.email.trim() === ''){
        return true
      }
      return false;
    },
    comments() {
      if (!this.order.log.length) return [];
      return this.order.log.filter((item) => item.action === "comment" || item.action === "comment_repairtime");
    },
    logs() {
      let availibleForCustomer = [
        "change_order_payment_status",
        "change_item_status",
        "change_order_status",
        "add_payment",
      ];
      let result = [];

      try {
        for (let i in this.comments) {
          let log = {};
          log.user = this.order.log[i].user.name;
          log.date = this.order.log[i].created_at;
          log.availibleForCustomer = availibleForCustomer.includes(
            this.order.log[i].action
          )
            ? '<i class="fa fa-user" aria-hidden="true"></i>&nbsp;'
            : "";
          let comment = JSON.parse(this.comments[i].new_value);
          let repairtime = '';

          if(this.comments[i].action === 'comment_repairtime'){
            repairtime = this.comments[i].part+': '
          }
          log.action =
            log.availibleForCustomer +
            (comment.sms
              ? '<i class="fa fa-mobile" aria-hidden="true" title="SMS"></i>&nbsp;'
              : "") +
            (comment.email
              ? '<i class="fa fa-envelope" aria-hidden="true" title="E-mail"></i>&nbsp;'
              : "") +
              repairtime +
            "<i>" +
            comment.text +
            "</i>";
          result.push(log);
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch(
          "common/showError",
          {
            error: `Error on parse JSON log for order #${this.order.human_number} (${this.order.id})`,
          },
          { root: true }
        );
      }

      return result;
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods: {
    async applySmsTemplate(template){
      return await this.$store.dispatch("sms_templates/applyTemplateForOrder",
          {
            order_id: this.orderId,
            template_id: template.id
          }
      ).then((text)=>{
        this.comment.text = text;
      })
    }
  },
  watch: {
    orderId(){
      this.comment.text = '';
    },
    async showWindow(value) {
      if (value && this.orderId>0) {
        await this.$store.dispatch("orders/orderShow", { id: this.orderId }).then((order)=>{
          this.order = order;
        });
        this.$store.dispatch("sms_templates/get");
      }
    },
  },
};
</script>
<style type="css">

</style>
